import { render, staticRenderFns } from "./SiteMapLinkUtils.vue?vue&type=template&id=1133b779&scoped=true"
import script from "./SiteMapLinkUtils.vue?vue&type=script&lang=ts"
export * from "./SiteMapLinkUtils.vue?vue&type=script&lang=ts"
import style0 from "./SiteMapLinkUtils.vue?vue&type=style&index=0&id=1133b779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133b779",
  null
  
)

export default component.exports